import { useSyncExternalStore } from 'react'
import { BellRing } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { getDesktopAlertPermission, requestDesktopAlertPermission, subscribeDesktopAlerts } from '@/lib/desktopAlerts'
import type { DesktopAlertPermission } from '@/types'

// #297 D2 — asks the user to turn on desktop alerts. Shown only while the browser has no answer yet; the
// browser's own question opens from this click (Firefox and Safari only ask from a user gesture), and once
// the user answers, yes or no, it goes away for good (the browser remembers; "no" can be changed in the
// browser's site settings, which the hint says). Not shown where the page cannot show notifications.
// Like "Sound off": a short word next to the icon from sm: up; phones get the icon with the full name.
export function DesktopAlertsButton() {
  const { t } = useTranslation('common')
  const permission = useSyncExternalStore<DesktopAlertPermission>(
    subscribeDesktopAlerts, getDesktopAlertPermission, () => 'unsupported',
  )
  if (permission !== 'default') return null
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => { void requestDesktopAlertPermission() }}
      className="h-8 w-8 gap-1.5 rounded-lg text-primary hover:text-primary hover:bg-primary/10 transition-colors sm:w-auto sm:px-2"
      title={t('header.desktopAlertsHint')}
      aria-label={t('header.desktopAlerts')}
    >
      <BellRing className="h-4 w-4" />
      <span data-desktop-alerts-word className="hidden text-xs font-medium sm:inline">{t('header.desktopAlertsShort')}</span>
    </Button>
  )
}
